import translations from '../translations/translation_index.js';

class TranslationContext
{
	constructor(name)
	{
		this.name = name;
		this._languages = {};
	}

	get language()
	{
		if (window.currentLanguageCode) { return window.currentLanguageCode; }
		else { return null; }
	}

	register(language, strings)
	{
		language = language || this.default_language;
		
		if (!this._languages[language]) 
			this._languages[language] = strings || {};
		else 
			this._languages[language] = {...strings, ...this._languages[language]}
	}

	get_string(key, default_value)
	{
		if (this.language)
		{
			let lang = this._languages[this.language];
			if (lang && lang[key]) { return lang[key]; }
		}
		return default_value || key;
	}

	translate(key, default_value)
	{
		let str = this.get_string(key, default_value);
			
		for (let i = arguments.length; i > 1; i--)
		{
			let regex = new RegExp('\\$' + (i - 2), 'g');
			str = str.replace(regex, arguments[i]);
		}

		if (!str || str.trim() === '') { return default_value; }
		else { return str; }
	}
}

export default class Translator
{
	constructor()
	{
		this._contexts = {};
		this.reload_all();
	}

	register(context)
	{
		let ctx = this._contexts[context.name];
		if (!ctx)
		{
			ctx = new TranslationContext(context.name);
			this._contexts[context.name] = ctx;
		}
		ctx.register(context.language, context.strings);
	}

	context(name)
	{
		let ctx = this._contexts[name];
		if (ctx) { return ctx; }
		else { throw 'Unknown context specified: ' + name; }
	}

	translate(context, key, default_value)
	{
		let ctx = this.context(context);
		if (ctx)
			return ctx.translate(key, default_value);
		else { throw 'Unknown context specified: ' + context; }
	}

	reload_all()
	{
		const self = this;
		let req = translations;
		let keys = Object.keys(req);

		_.each(keys, file => {
			let ctx = req[file];
			
			if (!ctx.name && ctx.sections)
			{
				_.each(ctx.sections, function (section, name) {
					let strings = {};
					_.each(section, s => {
						strings[s.key] = s.translation || s.source;
					});
					self.register({
						language: ctx.language,
						name: name,
						strings: strings
					});
				});
			}
		});
	}
}
